"use client"

import { useEffect, useState } from "react"
import { cn } from "@/lib/utils"

const sections = [
  { id: "core-philosophy", title: "Core Philosophy", number: "01" },
  { id: "methodological-trinity", title: "The Methodological Trinity", number: "02" },
  { id: "strategy", title: "Strategy", number: "02a" },
  { id: "tactics", title: "Tactics", number: "02b" },
  { id: "processes", title: "Processes", number: "02c" },
  { id: "data-governance", title: "Data Governance & AI", number: "03" },
  { id: "pincer-effect", title: "The Pincer Effect", number: "04" },
  { id: "susana", title: "Susana: Internal AI", number: "05" },
  { id: "conclusion", title: "Conclusion", number: "06" },
]

export function TableOfContents() {
  const [activeSection, setActiveSection] = useState<string>("")

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id)
          }
        })
      },
      {
        rootMargin: "-20% 0% -35% 0%",
        threshold: 0,
      }
    )

    sections.forEach(({ id }) => {
      const element = document.getElementById(id)
      if (element) observer.observe(element)
    })

    return () => observer.disconnect()
  }, [])

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    if (element) {
      element.scrollIntoView({ behavior: "smooth" })
    }
  }

  return (
    <nav className="space-y-1">
      <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-4">
        On this page
      </h3>
      {sections.map((section) => (
        <button
          key={section.id}
          onClick={() => scrollToSection(section.id)}
          className={cn(
            "w-full text-left px-3 py-2 text-sm rounded-md transition-all duration-200 flex items-center gap-3",
            activeSection === section.id
              ? "bg-accent-primary/10 text-accent-primary border-l-2 border-accent-primary"
              : "text-muted-foreground hover:text-foreground hover:bg-muted/50"
          )}
        >
          <span className="font-mono text-xs opacity-60">{section.number}</span>
          <span className={section.number.includes("a") || section.number.includes("b") || section.number.includes("c") ? "pl-2" : ""}>
            {section.title}
          </span>
        </button>
      ))}
    </nav>
  )
}
